import { rpcDefinition } from "@redotech/redo-merchant-platform-rpc/definition";
import type { ClientOptions } from "@redotech/rpc/client";
import { createRpcContractClient } from "@redotech/rpc/client";
import type { RedoPlatformRpcContract } from "./rpc-contract.generated";

export function createRedoPlatformRpcClient(
  options: ClientOptions<RedoPlatformRpcContract>,
): RedoPlatformRpcContract {
  return createRpcContractClient<RedoPlatformRpcContract>(
    rpcDefinition,
    options,
  );
}

export type RedoPlatformRpcClient = RedoPlatformRpcContract;
